import { Phone, Scopes } from './';
import { CompanyOutput } from './company.model';
import { UserRole } from './user.model';

/**
 * Result of the prospective-contact domain check
 * (`GET /api/v2/company/contact-domain-check`).
 *
 * `domainStatus` and `contacts` are omitted by the backend when they carry no
 * information, so both are optional.
 */
export interface ContactDomainCheck {
  /** Whether a company is known for the email's domain. */
  exist: boolean;

  domainStatus?: 'invalid' | 'excluded' | 'invalid-myself';

  contacts?: Array<{ email: string; existingContact: boolean }>;
}

export interface Customer {
  /** Relationship-contact row id, NOT a user id. */
  _id?: string;

  userId?: string;

  /**
   * Email address
   *
   */
  email?: string;

  /**
   * User's info
   *
   */
  person?: Person;

  /**
   * Company info
   *
   */
  company?: CompanyOutput;
  _scopes?: Scopes;

  /**
   * true - immediately accepts invitation like it used to be. Use in Contacts
   * false - creates a pending contact invitation and sends email. Use in Lender Connect for out of CRM invitations
   */
  autoAcceptInvitation?: boolean;

  /**
   * current deal id, only use in Lender Connect
   */
  dealInvitedToId?: string;
  /**
   * Text field "personal message" contents
   */
  customEmailContent?: string;

  invitationStatus?: InvitationStatus;
  areaOfResponsibility?: string;
  firstName?: string;
  middleName?: string;
  lastName?: string;
  companyName?: string;
  phone?: string;
  send?: boolean;
  user?: string;
}

export const InvitationStatuses = {
  UNKNOWN: 'UNKNOWN',
  PENDING: 'PENDING',
  ACCEPTED: 'ACCEPTED',
  DECLINED: 'DECLINED',
  INVITING: 'INVITING',
  DECLINING: 'DECLINING',
} as const;

export type InvitationStatus =
  (typeof InvitationStatuses)[keyof typeof InvitationStatuses];

export interface Staff {
  _id?: string;
  /**
   * Person id eg. "1232ba91-7c50-4bb1-a979-0700de41c0a4"
   *
   */
  personId?: string;

  /**
   * Email address
   *
   */
  email?: string;

  /**
   * Status
   * 900  - not active user
   * 1    - active user
   *
   */
  status?: number;

  /**
   * Role eg. "ADMIN" (BaseLineUserRole enum name from backend v2)
   *
   */
  role?: UserRole;

  /**
   * User type
   * 0 - non-user / not active
   * 1 - ?
   * 50 - lead
   * 200 - active user
   *
   */
  userFlag?: 0 | 1 | 50 | 200;

  /**
   *  User's details
   *
   */
  personApi?: PersonApi;
  /**
   * Company info
   *
   */
  acn?: CompanyOutput;
  areaOfResponsibility?: string;
  _scopes?: any;
}

export interface PersonApi {
  /**
   * Full name
   *
   */
  name?: string;

  /**
   * First name
   *
   */
  firstName?: string;

  /**
   * Middle name
   *
   */
  middleName?: string;

  /**
   * Last name
   *
   */
  lastName?: string;

  /**
   * Language eg. "pl_PL"
   *
   */
  language?: string;

  /**
   *  Person id eg. "e7ae97c2-e109-4924-889e-7f39236f2acc"
   *
   */
  personId?: string;

  /**
   * Email address
   *
   */
  email?: string;

  /**
   * User's phones
   *
   */
  phoneList?: Phone[];

  avatarDocId?: string;
}

export interface Person {
  /**
   * Full name
   *
   */
  name?: string;

  /**
   * First name
   *
   */
  fname?: string;

  /**
   * Middle name
   *
   */
  mname?: string;

  /**
   * Last name
   *
   */
  lname?: string;

  /**
   * Language eg. "pl_PL"
   *
   */
  lng?: string;

  /**
   *  Person id eg. "e7ae97c2-e109-4924-889e-7f39236f2acc"
   *
   */
  prsId?: string;

  /**
   *  Person id under its v2 name.
   *
   */
  personId?: string;

  /**
   *  Timezone eg. "Europe/Warsaw"
   *
   */
  tz?: string;

  /**
   * Email address
   *
   */
  email?: string;

  /**
   * User's phones
   *
   */
  phoneList?: Phone[];

  /**
   * Bit masks
   *
   */
  bitMasks?: any;

  avatarDocId?: string;
}
